// extracted by mini-css-extract-plugin
export var container = "_6h-0";
export var error = "_6h-9";
export var label = "_6h-5";
export var light = "_6h-6";
export var md = "_6h-3";
export var sm = "_6h-2";
export var thin = "_6h-8";
export var thinBold = "_6h-7";
export var vertical = "_6h-4";
export var xs = "_6h-1";